import Fixture from "./Fixture";

export default Fixture;
